var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.insideLandsHeaderIsVisible,
              expression: "insideLandsHeaderIsVisible",
            },
          ],
        },
        [
          _c("header", { staticClass: "layout-header" }, [
            _c(
              "div",
              {
                staticClass:
                  "db fixed w-100 message-bar flex flex-column justify-center items-center tc bg-navy z-header",
                class: {
                  "is-hidden":
                    _vm.messageBarIsClicked ||
                    _vm.scrolled ||
                    _vm.menuIconIsClicked,
                },
                staticStyle: { "z-index": "99999" },
              },
              [
                _c("message-bar-content", { key: _vm.$route.fullPath }),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass:
                      "db absolute right-0 mr2 nt1 f2 lh-solid is-cream pointer",
                    on: {
                      click: function ($event) {
                        _vm.messageBarIsClicked = !_vm.messageBarIsClicked
                        _vm.messageBarClosedMethod()
                      },
                    },
                  },
                  [_vm._v("×")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "db dn-ns fixed top-0 w-100 z-header",
                class: { "is-scrolled": _vm.fixedHeaderIsVisible },
              },
              [
                _c("div", {
                  staticClass:
                    "db relative w-100 h2 message-bar-spacer bg-beige",
                  class: {
                    "is-hidden":
                      _vm.messageBarIsClicked ||
                      _vm.scrolled ||
                      _vm.menuIconIsClicked,
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "il-header flex flex-row items-center",
                    class: { "bg-navy": _vm.menuIconIsClicked },
                  },
                  [
                    _c("div", { staticClass: "flex w-100 ph2 mh2 bg-beige" }, [
                      _c(
                        "div",
                        { staticClass: "tl" },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass:
                                "flex relative tc w5 il-header-cta has-red-bg mt1 overflow-hidden ttn pointer",
                              attrs: {
                                to: "/tickets/",
                                title: "Buy 2021 Tickets",
                                id: _vm.navigation.header_cta_button.id,
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.closeNav()
                                },
                              },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "text pointer is-lorano-bold" },
                                [_vm._v(" Buy 2021 Tickets ")]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "tc w-100" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex w-100 mw5 flex-row items-center justify-around",
                          },
                          _vm._l(_vm.navItems, function (item, index) {
                            return index > 0
                              ? _c(
                                  "span",
                                  { key: "il-nav-item-" + item.title },
                                  [
                                    item.is_link_out === true
                                      ? _c(
                                          "a",
                                          {
                                            staticClass:
                                              "flex relative tc no-underline pointer is-tablet-cond-bold is-black nav-link-primary",
                                            attrs: {
                                              href: item.link,
                                              title: item.title,
                                              id: "il-nav-item-" + item.title,
                                              target: "_blank",
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "text f3" },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(item.title) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "router-link",
                                          {
                                            staticClass:
                                              "flex relative tc no-underline pointer is-tablet-cond-bold is-black nav-link-primary",
                                            attrs: {
                                              to: item.link,
                                              title: item.title,
                                              id: "il-nav-item-" + item.title,
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "text f3" },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(item.title) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                  ],
                                  1
                                )
                              : _vm._e()
                          }),
                          0
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "tr w-auto flex flex-row items-center" },
                        [
                          _c(
                            "transition",
                            { attrs: { name: "slide-fade-logo" } },
                            [
                              _vm.fixedHeaderIsVisible || _vm.menuIconIsClicked
                                ? _c(
                                    "router-link",
                                    {
                                      staticClass:
                                        "dib is-white w-100 mr0 is-black",
                                      attrs: {
                                        to: "/",
                                        title: "Outside Lands",
                                      },
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.closeNav()
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            height: "25.444",
                                            viewBox: "0 0 36.486 25.444",
                                            width: "36.486",
                                            xmlns: "http://www.w3.org/2000/svg",
                                          },
                                        },
                                        [
                                          _c(
                                            "g",
                                            { attrs: { fill: "#200013" } },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  d: "m-22.689 0h-11.44a3.032 3.032 0 0 0 -3.032 3.032v19.38a3.032 3.032 0 0 0 3.032 3.032h11.44a3.032 3.032 0 0 0 3.032-3.032v-19.38a3.032 3.032 0 0 0 -3.032-3.032m-4.627 18.462h-2.184a.466.466 0 0 1 -.468-.462v-10.581a.466.466 0 0 1 .466-.466h2.186a.466.466 0 0 1 .466.466v10.581a.466.466 0 0 1 -.466.466",
                                                  transform:
                                                    "translate(37.161)",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("path", {
                                                attrs: {
                                                  d: "m-44.2-28.563h-10.1v-17.837a.385.385 0 0 0 -.385-.385h-6.422a.385.385 0 0 0 -.385.385v24.641a.385.385 0 0 0 .385.385h17.246a.385.385 0 0 0 .386-.385v-6.422a.385.385 0 0 0 -.386-.386",
                                                  transform:
                                                    "translate(79.966 46.794)",
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "dn db-ns fixed top-0 w-100 z-header il-header-desktop",
                class: { "is-scrolled": _vm.fixedHeaderIsVisible },
              },
              [
                _c("div", {
                  staticClass: "db relative w-100 message-bar-spacer bg-beige",
                  class: {
                    "is-hidden":
                      _vm.messageBarIsClicked ||
                      _vm.scrolled ||
                      _vm.menuIconIsClicked,
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "il-header-dt" }, [
                  _c("div", { staticClass: "il-header-dt-inner" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "relative flex flex-row items-center w-100 h-100",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "relative w-100 flex flex-row items-center justify-between il-header-desktop-nav-mw",
                          },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass:
                                  "flex relative tc w5 il-header-cta has-red-bg overflow-hidden ttn pointer",
                                attrs: {
                                  to: "/tickets/",
                                  title: "Buy 2021 Tickets",
                                  id: _vm.navigation.header_cta_button.id,
                                },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.closeNav()
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "text pointer is-lorano-bold",
                                  },
                                  [_vm._v(" Buy 2021 Tickets ")]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.navItems, function (item, index) {
                              return _c(
                                "span",
                                { key: "il-nav-item-" + item.title },
                                [
                                  item.is_link_out === true
                                    ? _c(
                                        "a",
                                        {
                                          staticClass:
                                            "flex relative tc no-underline pointer is-tablet-cond-bold is-black nav-link-primary",
                                          attrs: {
                                            href: item.link,
                                            title: item.title,
                                            id: "il-nav-item-" + item.title,
                                            target: "_blank",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "text f3" },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(item.title) +
                                                  "\n                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "router-link",
                                        {
                                          staticClass:
                                            "flex relative tc no-underline pointer is-tablet-cond-bold is-black nav-link-primary",
                                          attrs: {
                                            to: item.link,
                                            title: item.title,
                                            id: "il-nav-item-" + item.title,
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "text f3" },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(item.title) +
                                                  "\n                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                ],
                                1
                              )
                            }),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "dn db-ns tr absolute right-2" },
                          [
                            _c(
                              "transition",
                              { attrs: { name: "slide-fade-logo" } },
                              [
                                _vm.fixedHeaderIsVisible
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex flex-row items-center ttu f4 is-blue",
                                      },
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            staticClass:
                                              "dib w-100 mw24rem mt1 no-active-link",
                                            attrs: {
                                              to: "/",
                                              title: "Outside Lands",
                                            },
                                            nativeOn: {
                                              click: function ($event) {
                                                return _vm.closeNav()
                                              },
                                            },
                                          },
                                          [
                                            _c("simple-svg", {
                                              staticClass: "icon",
                                              attrs: {
                                                id: "ol19-header-scroll-logo",
                                                filepath:
                                                  "/assets/images/svg/ol21-lockup-header-scroll-new-dates.svg",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "header",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.insideLandsHeaderIsVisible,
              expression: "!insideLandsHeaderIsVisible",
            },
          ],
          staticClass: "layout-header",
        },
        [
          _c(
            "div",
            {
              staticClass:
                "db fixed w-100 message-bar flex flex-column justify-center items-center tc bg-navy z-header",
              class: {
                "is-hidden":
                  _vm.messageBarIsClicked ||
                  _vm.scrolled ||
                  _vm.menuIconIsClicked,
              },
              staticStyle: { "z-index": "99999" },
            },
            [
              _c("message-bar-content", { key: _vm.$route.fullPath }),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass:
                    "db absolute right-0 mr2 nt1 f2 lh-solid is-cream pointer",
                  on: {
                    click: function ($event) {
                      _vm.messageBarIsClicked = !_vm.messageBarIsClicked
                      _vm.messageBarClosedMethod()
                    },
                  },
                },
                [_vm._v("\n        ×\n      ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "db dn-ns fixed top-0 w-100 z-header",
              class: { "is-scrolled": _vm.fixedHeaderIsVisible },
            },
            [
              _c("div", {
                staticClass: "db relative w-100 h2 message-bar-spacer bg-beige",
                class: {
                  "is-hidden":
                    _vm.messageBarIsClicked ||
                    _vm.scrolled ||
                    _vm.menuIconIsClicked,
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "header flex flex-row items-center",
                  class: { "bg-navy": _vm.menuIconIsClicked },
                },
                [
                  _c("div", { staticClass: "header-inner w-100 ph2" }, [
                    _c(
                      "div",
                      { staticClass: "tl" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass:
                              "flex relative tc w5 header-cta has-red-bg overflow-hidden f4 f3-ns ttn pointer link",
                            attrs: {
                              to: _vm.navigation.header_cta_button.link,
                              title: _vm.navigation.header_cta_button.title,
                              id: _vm.navigation.header_cta_button.id,
                            },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.closeNav()
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "text is-lorano-bold" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.navigation.header_cta_button.title
                                  ) +
                                  "\n              "
                              ),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "tc w-100" }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "tr w-auto flex flex-row items-center" },
                      [
                        _c(
                          "transition",
                          { attrs: { name: "slide-fade-logo" } },
                          [
                            _vm.fixedHeaderIsVisible || _vm.menuIconIsClicked
                              ? _c(
                                  "router-link",
                                  {
                                    staticClass:
                                      "dib is-white w-100 mr3 is-black",
                                    attrs: { to: "/", title: "Outside Lands" },
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.closeNav()
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        attrs: {
                                          height: "25.444",
                                          viewBox: "0 0 36.486 25.444",
                                          width: "36.486",
                                          xmlns: "http://www.w3.org/2000/svg",
                                        },
                                      },
                                      [
                                        _c(
                                          "g",
                                          { attrs: { fill: "#200013" } },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d: "m-22.689 0h-11.44a3.032 3.032 0 0 0 -3.032 3.032v19.38a3.032 3.032 0 0 0 3.032 3.032h11.44a3.032 3.032 0 0 0 3.032-3.032v-19.38a3.032 3.032 0 0 0 -3.032-3.032m-4.627 18.462h-2.184a.466.466 0 0 1 -.468-.462v-10.581a.466.466 0 0 1 .466-.466h2.186a.466.466 0 0 1 .466.466v10.581a.466.466 0 0 1 -.466.466",
                                                transform: "translate(37.161)",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("path", {
                                              attrs: {
                                                d: "m-44.2-28.563h-10.1v-17.837a.385.385 0 0 0 -.385-.385h-6.422a.385.385 0 0 0 -.385.385v24.641a.385.385 0 0 0 .385.385h17.246a.385.385 0 0 0 .386-.385v-6.422a.385.385 0 0 0 -.386-.386",
                                                transform:
                                                  "translate(79.966 46.794)",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "dib relative nav-toggle pointer",
                            class: { "is-clicked": _vm.menuIconIsClicked },
                            on: {
                              click: function ($event) {
                                _vm.menuIconIsClicked = !_vm.menuIconIsClicked
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "line" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "line" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "line" }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dn db-ns fixed top-0 w-100 z-header header-desktop",
              class: { "is-scrolled": _vm.fixedHeaderIsVisible },
            },
            [
              _c("div", {
                staticClass: "db relative w-100 h2 message-bar-spacer bg-beige",
                class: {
                  "is-hidden":
                    _vm.messageBarIsClicked ||
                    _vm.scrolled ||
                    _vm.menuIconIsClicked,
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "relative flex flex-row items-center ph2-m ph4-l w-100 h-100 header",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "relative w-100 flex flex-row items-center justify-between header-desktop-nav-mw",
                    },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass:
                            "flex relative tc w5 header-cta has-red-bg overflow-hidden f3 ttn is-white pointer",
                          attrs: {
                            to: _vm.navigation.header_cta_button.link,
                            title: _vm.navigation.header_cta_button.title,
                            id: _vm.navigation.header_cta_button.id,
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.closeNav()
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "text" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.navigation.header_cta_button.title) +
                                "\n            "
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.navigation.navigation_items, function (item) {
                        return item.is_cta != true && item.is_link_out != true
                          ? _c(
                              "router-link",
                              {
                                key: item.title,
                                staticClass:
                                  "flex relative tc no-underline pointer is-tablet-cond-bold is-black nav-link-primary",
                                attrs: {
                                  to: item.link,
                                  title: item.title,
                                  id: item.id,
                                },
                              },
                              [
                                item.text_html
                                  ? _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(item.text_html),
                                      },
                                    })
                                  : item.is_primary
                                  ? _c("span", { staticClass: "text f3" }, [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(item.title) +
                                          "\n            "
                                      ),
                                    ])
                                  : _c("span", { staticClass: "text f4" }, [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(item.title) +
                                          "\n            "
                                      ),
                                    ]),
                              ]
                            )
                          : item.is_link_out
                          ? _c(
                              "a",
                              {
                                staticClass:
                                  "flex relative tc is-tablet-cond-bold is-black no-underline pointer nav-link-primary",
                                attrs: {
                                  href: item.link,
                                  target: "_blank",
                                  title: item.title,
                                  id: item.id,
                                },
                              },
                              [
                                _c("span", { staticClass: "text f4" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(item.title) +
                                      "\n            "
                                  ),
                                ]),
                              ]
                            )
                          : _c(
                              "router-link",
                              {
                                staticClass:
                                  "flex relative tc is-white no-underline pointer nav-link-search",
                                attrs: { to: "/search/", title: item.title },
                              },
                              [
                                item.text_html
                                  ? _c("span", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.searchBarIconIsClicked,
                                          expression: "!searchBarIconIsClicked",
                                        },
                                      ],
                                      domProps: {
                                        innerHTML: _vm._s(item.text_html),
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            )
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "dn db-l-header-logo tr absolute right-2" },
                    [
                      _c(
                        "transition",
                        { attrs: { name: "slide-fade-logo" } },
                        [
                          _vm.fixedHeaderIsVisible || _vm.menuIconIsClicked
                            ? _c(
                                "router-link",
                                {
                                  staticClass:
                                    "dib w-100 mr3 is-navy-fill no-active-link",
                                  attrs: {
                                    to: "/",
                                    title: "Outside Lands 2019",
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.closeNav()
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        height: "25.444",
                                        viewBox: "0 0 36.486 25.444",
                                        width: "36.486",
                                        xmlns: "http://www.w3.org/2000/svg",
                                      },
                                    },
                                    [
                                      _c("g", [
                                        _c("path", {
                                          attrs: {
                                            d: "m-22.689 0h-11.44a3.032 3.032 0 0 0 -3.032 3.032v19.38a3.032 3.032 0 0 0 3.032 3.032h11.44a3.032 3.032 0 0 0 3.032-3.032v-19.38a3.032 3.032 0 0 0 -3.032-3.032m-4.627 18.462h-2.184a.466.466 0 0 1 -.468-.462v-10.581a.466.466 0 0 1 .466-.466h2.186a.466.466 0 0 1 .466.466v10.581a.466.466 0 0 1 -.466.466",
                                            transform: "translate(37.161)",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("path", {
                                          attrs: {
                                            d: "m-44.2-28.563h-10.1v-17.837a.385.385 0 0 0 -.385-.385h-6.422a.385.385 0 0 0 -.385.385v24.641a.385.385 0 0 0 .385.385h17.246a.385.385 0 0 0 .386-.385v-6.422a.385.385 0 0 0 -.386-.386",
                                            transform:
                                              "translate(79.966 46.794)",
                                          },
                                        }),
                                      ]),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "dn db-xl-header-logo tr absolute right-2" },
                    [
                      _c("transition", { attrs: { name: "slide-fade-logo" } }, [
                        _vm.fixedHeaderIsVisible
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "flex flex-row items-center ttu f4 is-blue",
                              },
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass:
                                      "dib w-100 mw24rem mt1 no-active-link",
                                    attrs: { to: "/", title: "Outside Lands" },
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.closeNav()
                                      },
                                    },
                                  },
                                  [
                                    _c("simple-svg", {
                                      staticClass: "icon",
                                      attrs: {
                                        id: "ol19-header-scroll-logo",
                                        filepath:
                                          "/assets/images/svg/ol21-lockup-header-scroll-new-dates.svg",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c("page-sub-nav"),
            ],
            1
          ),
          _vm._v(" "),
          _c("transition", { attrs: { name: "menu-transition" } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.menuIconIsClicked,
                    expression: "menuIconIsClicked",
                  },
                ],
                staticClass: "db dn-ns menu menu-transition z-menu",
              },
              [
                _c("transition", { attrs: { name: "nav-transition" } }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.menuIconIsClicked,
                          expression: "menuIconIsClicked",
                        },
                      ],
                      staticClass: "layout-header-sidebar bg-navy",
                    },
                    [_c("mobile-nav")],
                    1
                  ),
                ]),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("header-spacer"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }